import { Component, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { StylingService } from '../services/style-service/styling.service';
import { AuthService } from '../services/auth-service/auth.service';
import { UserService } from '../services/user-service/user.service';
import { IframeRecivedService } from '../shared/navbar/navbar-vesax/iframe-recieved.service';
import { Router } from '@angular/router';
import { EventsService } from '../services/events-service/events.service';

@Component({
  selector: 'app-dark-viho',
  templateUrl: './app-dark-viho.component.html',
  styleUrls: ['./app-dark-viho.component.scss'],
  standalone:false
})
export class AppDarkVihoComponent implements OnInit {

  title = 'webconfigurator';
  burgerMenu: boolean = false;
  toggleSub = new Subject<any>();

  privateProfile$: any;
  privateProfile: any;
  authToken!:string | null;

  isEventsActive:boolean=false;
  profileLoaded:any = false;

  probileSub!:Subscription


  constructor(
    public styleService: StylingService,
    public auth: AuthService,
    public userService: UserService ,
    public iframeRecivedService: IframeRecivedService,
    private router:Router,
    public eventsServive:EventsService
  ) { 
    let bodyQuerySelectror = document.querySelectorAll('body');
    bodyQuerySelectror.forEach((body)=>{
      body.classList.add('desktopDarkTheme')
    })
  }

  ngOnInit(): void {
    this.router.events.subscribe((event:any) => {
      if (event && typeof event.url!==undefined) {
        // Check if the URL starts with '/events' or '/event/details'
        console.log('event.url',event.url)
        this.isEventsActive = event.url?.startsWith('/events') || event.url?.startsWith('/event/details');
      }
    });
    if(this.auth.loggedIn$){
      this.probileSub = this.userService.profileSub.subscribe(profile=>{
        this.privateProfile = profile
      })
      console.log('this.privateProfile', this.privateProfile)
      console.log('user-info')
    }
    if(!this.privateProfile){
      let token = this.auth.getToken();
      this.privateProfile$ = this.userService.getPrivateProfile(token).subscribe(data => {
        this.privateProfile = data;
        this.profileLoaded = true;
        console.log('data', data)
      });
    }
  }

  onLogout(){
    this.auth.logout();
  }

  ngOnDestroy(){
    this.privateProfile$.unsubscribe();
  }

  toggle() {
    this.toggleSub.next(null);
  }

}
